import { ApolloClient, InMemoryCache, } from '@apollo/client/core';
import { createHttpLink } from '@apollo/client/link/http';
import { ApolloLink } from '@apollo/client/link/core/ApolloLink';
export const createApiClient = (options) => {
    const endpoint = options.apiEndpoint || `${options.apiBase}/graphql`;
    const httpLink = createHttpLink({
        uri: endpoint,
    });
    const cache = new InMemoryCache();
    let link;
    if (options.middleware) {
        link = ApolloLink.from([
            ...options.middleware,
            httpLink,
        ]);
    }
    else {
        link = httpLink;
    }
    return new ApolloClient({
        link,
        cache,
        queryDeduplication: true,
    });
};
//# sourceMappingURL=apiClient.js.map